let atInternet = () => {}

if (window.ATInternet) {
  const atTag = new window.ATInternet.Tracker.Tag()
  const AT_INTERNET_SITE_ID = process.env.AT_INTERNET_SITE_ID

  atInternet = ({ path, name }) => {
    const pageData = {
      name: path,
      level1: AT_INTERNET_SITE_ID,
      level2: 27,
      chapter1: 'live',
      page: path,
      platform: 'site',
      broadcaster: 'avrotros',
      program: 'gouden radioring',
      level2type: 'portal',
      eventtype: 'index',
      mediatype: 'general',
      nb_idfa: 'no_value',
      thema: 'muziek'
    }

    atTag.page.set(pageData)
    atTag.dispatch()
  }
}

export default atInternet



// WEBPACK FOOTER //
// ./src/router/atInternet.js